// Measure at 100px so the returned font size can scale with a token's width.
export const fitRandomTeamsName = (name: string, measure: (text: string) => number, preferredSizeCqw = 13) => {
    const words = name.trim().split(/\s+/);
    let lines = [words.join(" ")];
    let width = measure(lines[0]);

    if (width * preferredSizeCqw / 100 > 90) {
        for (let split = 1; split < words.length; split += 1) {
            const candidate = [words.slice(0, split).join(" "), words.slice(split).join(" ")];
            const candidateWidth = Math.max(...candidate.map(measure));
            if (candidateWidth < width) {
                lines = candidate;
                width = candidateWidth;
            }
        }
    }

    return { lines, sizeCqw: Math.min(preferredSizeCqw, 9000 / Math.max(width, 1)) };
};
